<template>
  <div class="pageHeader">
    <div class="pageTitle">
      <slot name="left">
        {{ title }}
        <span v-if="tip" class="pageTitle-tip">{{ tip }}</span>
      </slot>
    </div>
    <div class="pageTitle-right">
      <slot name="right"><slot /></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PageHeader',
  props: {
    tip: {
      type: String,
      default: '',
    },
  },
  computed: {
    title() {
      return (this.$route.meta && this.$route.meta.title) || ''
    },
  },
}
</script>

<style lang="less" scoped>
.pageHeader {
  height: 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 0 0 56px;
  padding: 0 20px;
  background-color: #fff;
  border-radius: 4px 4px 0 0;
}

.pageTitle {
  min-width: 0;
  color: #272e3b;
  font-size: 16px;
  font-weight: 400;
}

.pageTitle-tip {
  margin-left: 10px;
  color: #8c8c8c;
  font-size: 12px;
}

.pageTitle-right {
  display: flex;
  align-items: center;
  gap: 12px;

  /deep/ .button,
  /deep/ .extra-button {
    margin-left: 0;
  }
}
</style>
